/**
 * Description: 菜单资源管理相关API
 * Date: 2024
 **/
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import request from './request'

const serveName = process.env.VUE_APP_SERVENAME

// 获取资源列表
export const getResourceList = (data?: any) => request(`/${serveName}/sys/res`, null, 'POST_JSON', data)

// 新增资源
export const addResource = (data: {
  name: string // 非空
  resType: number // 1为菜单，2为button，非空
  parentId: number // resType为菜单时，此值代表父级菜单；为button时，代表此按钮所属菜单。非空
  priority: number // 排序值，非空
  permission: string // 权限资源码，非空
  icon?: string // 预留
  address?: string // 菜单路由,resType为菜单时必填
  url?: string // 资源对应访问接口
}) => request(`/${serveName}/sys/addRes`, null, 'POST_JSON', data)

// 更新资源
export const updateResource = (data: {
  id: string // 当前数据主键id，非空
  name: string // 修改后名称，非空
  resType: number // 资源类型，1为菜单，2为button，非空
  parentId: number // resType为菜单时，此值代表父级菜单；为button时，代表此按钮所属菜单。非空
  priority: number // 排序值，非空
  permission: string // 权限资源码，非空
  icon?: string // 图标名
  address?: string // 菜单路由,resType为菜单时必填
  url?: string // 资源对应访问接口，非空
}) => request(`/${serveName}/sys/updateRes`, null, 'POST_JSON', data)

// 排序资源
export const sortResource = (data: {
  id: number // 当前拖动资源id
  resType: number // 排序当前元素的类型
  targetRowId?: number // 拖动至目标位置行id
  targetRowType?: string // 拖动至目标位置行的上top、下bottom
}) => request(`/${serveName}/sys/sortRes`, null, 'POST_JSON', data)

// 删除资源
export const deleteResource = (
  data: Array<{
    id: string // 非空
    resType: number // 1为菜单，2为button，非空
  }>,
) => request(`/${serveName}/sys/delRes`, null, 'POST_JSON', data)
